<template>
    <div id="ambis-test-bundle-form" class="mb-10">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard' },
                {
                    text: 'Ambis Test',
                    to: { path: '/ambis-test' },
                },
                {
                    text: 'List Bundle Subtes',
                    to: { path: '/ambis-test/list-bundle' },
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Bundle Subtes'
                        : 'Ubah Bundle Subtes',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="d-flex">
            <h3 class="header-text font-weight-bold">
                {{
                    !$route.query.id ? "Tambah Bundle Soal" : "Ubah Bundle Soal"
                }}
            </h3>
        </div>

        <div>
            <v-card flat>
                <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <div>
                            <label>
                                Nama Bundle Subtes
                                <span class="red--text">*</span></label
                            >
                            <v-text-field
                                v-model="form.name"
                                placeholder="Masukan nama bundle subtes"
                                outlined
                                dense
                                maxlength="100"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'Nama bundle subtes wajib diisi!',
                                ]"
                                required
                                class="mt-1"
                            />
                        </div>

                        <div>
                            <label>
                                Deskripsi Bundle
                                <span class="red--text">*</span></label
                            >
                            <v-text-field
                                v-model="form.description"
                                placeholder="Masukan deskripsi subtes bundle"
                                outlined
                                dense
                                maxlength="150"
                                :rules="[
                                    (v) =>
                                        !!v ||
                                        'Deskripsi bundle subtes wajib diisi!',
                                ]"
                                required
                                class="mt-1"
                            />
                        </div>

                        <div>
                            <label>
                                Mata Pelajaran
                                <span class="red--text">*</span>
                            </label>

                            <v-autocomplete
                                v-model="form.mapel"
                                placeholder="Pilih Mata Pelajaran"
                                outlined
                                dense
                                class="mt-1"
                                :items="mapelList"
                                item-text="nama"
                                item-value="id"
                                @change="mapelSelected($event)"
                            ></v-autocomplete>
                        </div>

                        <div>
                            <v-card outlined>
                                <v-card-text>
                                    <div class="font-weight-600 blacknew--text">
                                        Perakitan Soal
                                    </div>

                                    <div class="lightgreynew--text mb-3">
                                        Rakit soal dengan mencari bab atau kode
                                        soal melalui tombol di bawah
                                    </div>

                                    <app-assemblesubtest
                                        :pdisabled="subject"
                                        :subject="subject"
                                        :key="keyAssembler"
                                        :bundles="bundles"
                                        v-on:updated="detailsUpdated($event)"
                                    ></app-assemblesubtest>
                                </v-card-text>
                            </v-card>
                        </div>

                        <div class="mt-5" align="right">
                            <v-btn
                                depressed
                                class="mr-2"
                                @click="$router.go(-1)"
                            >
                                Kembali
                            </v-btn>

                            <v-btn
                                depressed
                                color="blew"
                                class="white--text"
                                :loading="loading"
                                @click="bundleProcess()"
                            >
                                Simpan
                            </v-btn>
                        </div>
                    </v-form>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import AssembleSubTest from "@/modules/tryout/components/AssembleSubTest";
import ChooseMapel from "@/modules/tryout/components/ChooseMapel";
import axios from "axios";
import ambis_test from "../services/ambis_test";
import firebase from "firebase";

export default {
    components: {
        "app-assemblesubtest": AssembleSubTest,
        "app-choosemapel": ChooseMapel,
    },

    data() {
        return {
            loading: false,
            form: {
                name: null,
                description: null,
                total_questions: 0,
                bundle_soal: null,
            },
            subtest: {
                id: 0,
                tryout_id: 0,
                subject_code: "",
                subject_name: "",
                subject_picture: "",
                duration: 0,
                item_count: 0,
                details: [],
                kkm: 0,
            },
            keyAssembler: 0,
            subject: null,
            bundles: null,
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    mounted() {
        if (this.$route.query.id) {
            this.getDetailBundle();
        }
    },

    methods: {
        getDetailBundle() {
            var context = this;
            const bundle_id = context.$route.query.id;

            ambis_test.getDetailBundle(bundle_id, function (result) {
                if (result.success) {
                    const data = result.data;
                    context.form = data;

                    context.mapelSelected({});
                    context.getDetailBundlesFirebase();
                }
            });
        },

        detailsUpdated(data) {
            this.subtest.tryout_id = this.$store.state.tryout.id;
            this.subtest.details = data;
            this.subtest.item_count = data.length;

            const bundle_items = {
                items: data,
            };

            this.form.bundle_soal = JSON.stringify(bundle_items) || "";
            this.form.total_questions = data ? data.length : 0;
        },

        mapelSelected(data) {
            this.subject = this.mapelList.find((e) => e.id === data);
        },

        async bundleProcess() {
            var context = this;
            const bundle_id = context.$route.query.id;
            context.loading = true;

            if (context.$refs.form.validate()) {
                if (!bundle_id) {
                    ambis_test.addBundle(context.form, function (result) {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Data Bundle Subtes Berhasil Ditambahkan`,
                                type: "success",
                            });

                            context.$router.go(-1);
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Gagal menambahkan data bundle subtes`,
                                type: "error",
                            });
                        }

                        context.loading = false;
                    });
                } else {
                    ambis_test.editBundle(
                        bundle_id,
                        context.form,
                        function (result) {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Data Bundle Subtes Berhasil Diubah`,
                                    type: "success",
                                });

                                context.$router.go(-1);
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal mengubah data bundle subtes`,
                                    type: "error",
                                });
                            }

                            context.loading = false;
                        }
                    );
                }
            }
        },

        async getDetailBundlesFirebase() {
            this.loading = true;

            try {
                const docRef = firebase
                    .firestore()
                    .collection("ambis_test_question")
                    .doc(this.form.bundle_code)
                    .collection(`${this.form.bundle_code}_00001`)
                    .doc("question");

                const doc = await docRef.get();

                if (doc.exists) {
                    var data = doc.data().body;
                    data = JSON.parse(data);
                    this.bundles = data.items || [];

                    if (this.bundles.length) {
                        const mapel_code = this.bundles[0].item_code;
                        const mapel_subtr = mapel_code.substr(2, 2);

                        this.form.mapel = parseInt(mapel_subtr);
                        this.subject = this.mapelList.find(
                            (e) => e.id === this.form.mapel
                        );
                    }
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// CreateBundle.vue?066a56e9